import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CookiesConsentService {

  // tslint:disable-next-line:ban-types
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.consented.next(this.isConsentedFromStorage);
  }

  private get isConsentedFromStorage() {
    if (isPlatformBrowser(this.platformId)) {
      const isConsentedString = localStorage.getItem(CookiesConsentService.CONSENT_STORAGE_KEY);
      return isConsentedString === 'true';
    }
    return true;
  }

  private static CONSENT_STORAGE_KEY = 'cookies-consent';
  private consented = new BehaviorSubject(false);

  private setConsented(consented: boolean) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(CookiesConsentService.CONSENT_STORAGE_KEY, consented.toString());
    }
  }

  public cookiesConsented() {
    this.consented.next(true);
    this.setConsented(true);
  }

  public get isConsented(): Observable<boolean> {
    return this.consented.asObservable();
  }
}
